import { ScrollingNumberCounter, Text } from "@clipboard-health/ui-components";
import { Box, Stack, type Theme, ThemeProvider, useTheme } from "@mui/material";
import type { ReactNode } from "react";

const SCORE_ANIMATION_DURATION_MS = 1500;

const SCORE_FONT_SIZE = "7.25rem";

interface CancellationScoreDisplayProps {
  score: number;
  animated?: boolean;
  startScore?: number;
  isRestricted?: boolean;
  children?: ReactNode;
}

export function CancellationScoreDisplay(props: CancellationScoreDisplayProps): JSX.Element {
  const { score, animated = false, startScore, isRestricted = false, children } = props;
  const theme = useTheme();

  return (
    <Stack alignItems="center" textAlign="center" spacing={6}>
      <Stack spacing={0} alignItems="center">
        <Text
          variant="h3"
          textAlign="center"
          sx={{
            color: (t) => (isRestricted ? t.palette.error.main : t.palette.intent?.error.text),
          }}
        >
          Shift cancelled{isRestricted ? "." : ""}
        </Text>
        {isRestricted ? (
          <Text
            variant="h3"
            textAlign="center"
            sx={{
              color: (t) => t.palette.error.main,
            }}
          >
            Your account is Restricted
          </Text>
        ) : null}
      </Stack>
      <Stack sx={{ marginTop: "24px !important" }} alignItems="center">
        <Text
          variant="body2"
          sx={(t) => ({
            color: t.palette.text.secondary,
          })}
        >
          Your new Clipboard Score
        </Text>
        <Box sx={{ marginTop: 8 }}>
          {animated ? (
            <ThemeProvider
              theme={(outerTheme: Theme) => ({
                ...outerTheme,
                typography: {
                  ...outerTheme.typography,
                  h1: {
                    ...outerTheme.typography.h1,
                    fontSize: SCORE_FONT_SIZE,
                  },
                },
              })}
            >
              <ScrollingNumberCounter
                startValue={startScore ?? score}
                endValue={score}
                duration={SCORE_ANIMATION_DURATION_MS}
                variant="h1"
                color={theme.palette.text.primary}
              />
            </ThemeProvider>
          ) : (
            <Text
              color={(t) => t.palette.text.primary}
              sx={{
                fontSize: SCORE_FONT_SIZE,
                fontWeight: 300,
                lineHeight: "96px",
                letterSpacing: "-0.01em",
                textAlign: "center",
                width: "100%",
              }}
            >
              {score}
            </Text>
          )}
        </Box>
      </Stack>
      {children}
    </Stack>
  );
}
